// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectCard__container___UAbHc {
    --smart-animate-timing-function: var(--geomate-time-function);
    --smart-animate-duration: var(--geomate-time-duration);

    overflow: hidden;

    width: 37.6rem;
    height: 22.7rem;

    border-radius: var(--geomate-border-radius);
    box-shadow: var(--shadow-group);

    transition: var(--smart-animate-timing-function) var(--smart-animate-duration);

    &:hover {
        box-shadow: var(--shadow-modal);
    }
}

.ProjectCard__footerRight___Uzas8 {
    transform: translateX(calc(var(--space-2xl) + var(--space-xs)));
    align-items: center;
    transition: var(--smart-animate-timing-function) var(--smart-animate-duration);
}

.ProjectCard__container___UAbHc:hover .ProjectCard__footerRight___Uzas8 {
    transform: translateX(-(calc(var(--space-2xl) + var(--space-xs))));
}

.ProjectCard__headerText___Gdkfe {
    line-height: 3.2rem;

    &:hover {
        cursor: pointer;
        color: var(--color-bg-link);
    }
}

.ProjectCard__headerButtons___uGlBF {
    display: flex;
    gap: var(--space-xs);
    align-items: center;
}

.ProjectCard__headerButtons___uGlBF > .ProjectCard__hidable___Fb3a1 {
    opacity: 0;
    transition: var(--smart-animate-timing-function) var(--smart-animate-duration);
}

.ProjectCard__container___UAbHc:hover .ProjectCard__headerButtons___uGlBF > .ProjectCard__hidable___Fb3a1 {
    opacity: 1;
}

.ProjectCard__headerTextContainer___uydO0 {
    min-width: 0;
}

.ProjectCard__body___S5crb {
    border-bottom: solid 0.1rem var(--color-bg-border);
}

.ProjectCard__bodyItemText___wTkZv {
    line-height: 2.1rem;
}

.ProjectCard__footerStatusText___iUtNk {
    line-height: 1.8rem;
}

.ProjectCard__alignCenter___vYXtT {
    align-items: center;
}

.ProjectCard__editedPart___C7Rxe {
    padding-top: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Main/ProjectsView/ProjectsCardsView/ProjectCard/ProjectCard.css"],"names":[],"mappings":"AAAA;IACI,6DAA6D;IAC7D,sDAAsD;;IAEtD,gBAAgB;;IAEhB,cAAc;IACd,eAAe;;IAEf,2CAA2C;IAC3C,+BAA+B;;IAE/B,8EAA8E;;IAE9E;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI,+DAA+D;IAC/D,mBAAmB;IACnB,8EAA8E;AAClF;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,mBAAmB;;IAEnB;QACI,eAAe;QACf,2BAA2B;IAC/B;AACJ;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,8EAA8E;AAClF;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".container {\n    --smart-animate-timing-function: var(--geomate-time-function);\n    --smart-animate-duration: var(--geomate-time-duration);\n\n    overflow: hidden;\n\n    width: 37.6rem;\n    height: 22.7rem;\n\n    border-radius: var(--geomate-border-radius);\n    box-shadow: var(--shadow-group);\n\n    transition: var(--smart-animate-timing-function) var(--smart-animate-duration);\n\n    &:hover {\n        box-shadow: var(--shadow-modal);\n    }\n}\n\n.footerRight {\n    transform: translateX(calc(var(--space-2xl) + var(--space-xs)));\n    align-items: center;\n    transition: var(--smart-animate-timing-function) var(--smart-animate-duration);\n}\n\n.container:hover .footerRight {\n    transform: translateX(-(calc(var(--space-2xl) + var(--space-xs))));\n}\n\n.headerText {\n    line-height: 3.2rem;\n\n    &:hover {\n        cursor: pointer;\n        color: var(--color-bg-link);\n    }\n}\n\n.headerButtons {\n    display: flex;\n    gap: var(--space-xs);\n    align-items: center;\n}\n\n.headerButtons > .hidable {\n    opacity: 0;\n    transition: var(--smart-animate-timing-function) var(--smart-animate-duration);\n}\n\n.container:hover .headerButtons > .hidable {\n    opacity: 1;\n}\n\n.headerTextContainer {\n    min-width: 0;\n}\n\n.body {\n    border-bottom: solid 0.1rem var(--color-bg-border);\n}\n\n.bodyItemText {\n    line-height: 2.1rem;\n}\n\n.footerStatusText {\n    line-height: 1.8rem;\n}\n\n.alignCenter {\n    align-items: center;\n}\n\n.editedPart {\n    padding-top: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ProjectCard__container___UAbHc`,
	"footerRight": `ProjectCard__footerRight___Uzas8`,
	"headerText": `ProjectCard__headerText___Gdkfe`,
	"headerButtons": `ProjectCard__headerButtons___uGlBF`,
	"hidable": `ProjectCard__hidable___Fb3a1`,
	"headerTextContainer": `ProjectCard__headerTextContainer___uydO0`,
	"body": `ProjectCard__body___S5crb`,
	"bodyItemText": `ProjectCard__bodyItemText___wTkZv`,
	"footerStatusText": `ProjectCard__footerStatusText___iUtNk`,
	"alignCenter": `ProjectCard__alignCenter___vYXtT`,
	"editedPart": `ProjectCard__editedPart___C7Rxe`
};
export default ___CSS_LOADER_EXPORT___;
